// HQ总部、JV代理、SC售后公司、CS租赁方

const changeRules = [
  {
    name: '租赁合同',
    code: 'lease',
    value: '20',
    children: [
      {
        name: '审批通过',
        code: 'Pass',
        value: '10',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '总部已发货',
        code: 'hq_shipped',
        value: '21',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '售后公司已发货',
        code: 'sc_shipped',
        value: '23',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '租赁方已收货',
        code: 'cs_received',
        value: '24',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: 'JV', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: 'SC', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: 'JV', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '已生效',
        code: 'executed',
        value: '20',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: 'JV', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: 'JV,HQ', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '售后公司已收货',
        code: 'sc_received',
        value: '22',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: 'JV', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: 'SC', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: 'JV', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '已启租',
        code: 'lessee',
        value: '36',
        children: [
          { roleCode: 'JV', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: 'JV', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: 'SC', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: 'JV', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: 'JV', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: 'JV', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: 'JV', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
    ],
  },
  {
    name: '续租合同',
    code: 'lease',
    value: '21',
    children: [
      {
        name: '审批通过',
        code: 'Pass',
        value: '10',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '总部已发货',
        code: 'hq_shipped',
        value: '21',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '售后公司已发货',
        code: 'sc_shipped',
        value: '23',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '租赁方已收货',
        code: 'cs_received',
        value: '24',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: 'JV', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: 'SC', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: 'JV', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '已生效',
        code: 'executed',
        value: '20',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: 'JV,HQ', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: 'JV,HQ', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '售后公司已收货',
        code: 'sc_received',
        value: '22',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: 'JV', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: 'SC', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: 'JV', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '已启租',
        code: 'lessee',
        value: '36',
        children: [
          { roleCode: 'JV', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: 'JV', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: 'SC', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: 'JV', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: 'JV', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: 'JV', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: 'JV', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
    ],
  },
  {
    name: '框架订单',
    code: 'f_order',
    value: '31',
    children: [
      {
        name: '审批通过',
        code: 'Pass',
        value: '10',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '总部已发货',
        code: 'hq_shipped',
        value: '21',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '售后公司已发货',
        code: 'sc_shipped',
        value: '23',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '租赁方已收货',
        code: 'cs_received',
        value: '24',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: 'JV,HQ', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: 'SC', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: 'JV,HQ', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '已生效',
        code: 'executed',
        value: '20',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: 'JV,HQ', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: 'JV,HQ', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '售后公司已收货',
        code: 'sc_received',
        value: '22',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: 'JV,HQ', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: 'SC', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: 'JV,HQ', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '已启租',
        code: 'lessee',
        value: '36',
        children: [
          { roleCode: 'JV,HQ', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: 'JV,HQ', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: 'SC', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: 'JV,HQ', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: 'JV,HQ', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },

          { roleCode: 'JV,HQ', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: 'JV,HQ', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
    ],
  },
  {
    name: '试用订单',
    code: 't_order',
    value: '10',
    children: [
      {
        name: '审批通过',
        code: 'Pass',
        value: '10',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '总部已发货',
        code: 'hq_shipped',
        value: '21',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '售后公司已收货',
        code: 'sc_received',
        value: '22',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: 'JV', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '售后公司已发货',
        code: 'sc_shipped',
        value: '23',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '租赁方已收货',
        code: 'cs_received',
        value: '24',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: 'JV', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '已生效',
        code: 'executed',
        value: '20',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: 'JV', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: '', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: 'JV,HQ', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '已试用',
        code: 'try',
        value: '32',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: 'JV', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
      {
        name: '已启租',
        code: 'lessee',
        value: '36',
        children: [
          { roleCode: '', name: '暂停使用', code: 'pause_use', value: 'pause_use' },
          { roleCode: '', name: '终止合同', code: 'stop_contract', value: 'stop_contract' },
          { roleCode: '', name: '更换设备', code: 'device', value: 'device' },
          { roleCode: '', name: '变更售后公司', code: 'after_service', value: 'after_service' },
          { roleCode: '', name: '变更启租日期', code: 'rent_time', value: 'rent_time' },
          { roleCode: 'JV', name: '终止试用', code: 'stop_test', value: 'stop_test' },
          { roleCode: '', name: '终止设备租赁', code: 'stop_device_rent', value: 'stop_device_rent' },
          { roleCode: '', name: '变更支付周期', code: 'payment_period', value: 'payment_period' },
        ],
      },
    ],
  },
  {
    name: '销售订单',
    code: 'sales',
    value: '40',
    children: [
      {
        name: '已生效',
        code: 'executed',
        value: '20',
        children: [
          { roleCode: 'SC', name: '更换销售设备', code: 'change_sale_device', value: 'change_sale_device' },
          { roleCode: 'JV,HQ', name: '终止设备销售', code: 'stop_device_sale', value: 'stop_device_sale' },
        ],
      },
      {
        name: '总部已发货',
        code: 'hq_shipped',
        value: '21',
        children: [
          { roleCode: 'SC', name: '更换销售设备', code: 'change_sale_device', value: 'change_sale_device' },
          { roleCode: 'JV,HQ', name: '终止设备销售', code: 'stop_device_sale', value: 'stop_device_sale' },
        ],
      },

      {
        name: '售后公司已发货',
        code: 'sc_shipped',
        value: '23',
        children: [
          { roleCode: 'SC', name: '更换销售设备', code: 'change_sale_device', value: 'change_sale_device' },
          { roleCode: 'JV,HQ', name: '终止设备销售', code: 'stop_device_sale', value: 'stop_device_sale' },
        ],
      },
      {
        name: '乙方已收货',
        code: 'cs_received',
        value: '24',
        children: [
          { roleCode: 'SC', name: '更换销售设备', code: 'change_sale_device', value: 'change_sale_device' },
          { roleCode: 'SC,CS', name: '确认售卖', code: 'sales', value: 'sales' },
          { roleCode: 'JV,HQ', name: '终止设备销售', code: 'stop_device_sale', value: 'stop_device_sale' },
        ],
      },
      {
        name: '部分购机',
        code: 'part _sale',
        value: '51',
        children: [
          { roleCode: 'SC', name: '更换销售设备', code: 'change_sale_device', value: 'change_sale_device' },
          { roleCode: 'JV,HQ', name: '终止设备销售', code: 'stop_device_sale', value: 'stop_device_sale' },
        ],
      },
      {
        name: '已购机',
        code: 'sales',
        value: '52',
        children: [
          { roleCode: 'SC', name: '更换销售设备', code: 'change_sale_device', value: 'change_sale_device' },
          { roleCode: 'JV,HQ', name: '终止设备销售', code: 'stop_device_sale', value: 'stop_device_sale' },
        ],
      },
    ],
  },
];

const handleRules = [
  {
    name: '租赁合同',
    code: 'lease',
    value: '20',
    children: [
      {
        name: '已启租',
        code: 'lessee',
        value: '36',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: 'JV', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '草稿',
        code: 'draft',
        value: '1',
        children: [
          { roleCode: 'JV', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'JV', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: 'JV', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '审批中',
        code: 'approval',
        value: '6',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: 'JV', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: 'JV,HQ,CS,SC', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '审批通过',
        code: 'Pass',
        value: '10',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: 'JV', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },

          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '已生效',
        code: 'executed',
        value: '20',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '总部已发货',
        code: 'hq_shipped',
        value: '21',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '售后公司已发货',
        code: 'sc_shipped',
        value: '23',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '售后公司已收货',
        code: 'sc_received',
        value: '22',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'CS,SC', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '租赁方已收货',
        code: 'cs_received',
        value: '24',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '已作废',
        code: 'cancelled',
        value: '100',
        children: [
          { roleCode: 'JV', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: '', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '审批拒绝',
        code: 'refuse',
        value: '90',
        children: [
          { roleCode: 'JV', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: 'JV', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: '', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '已终止',
        code: 'terminated',
        value: '70',
        children: [{ roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' }],
      },
      {
        name: '已到期',
        code: 'expired',
        value: '80',
        children: [
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'JV', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
        ],
      },
    ],
  },
  {
    name: '续租合同',
    code: 'lease',
    value: '21',
    children: [
      {
        name: '已启租',
        code: 'lessee',
        value: '36',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: 'JV', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '草稿',
        code: 'draft',
        value: '1',
        children: [
          { roleCode: 'JV', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'JV', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: 'JV', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '审批中',
        code: 'approval',
        value: '6',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: 'JV', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: 'JV,HQ,CS,SC', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '审批通过',
        code: 'Pass',
        value: '10',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: 'JV', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },

          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '已生效',
        code: 'executed',
        value: '20',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '总部已发货',
        code: 'hq_shipped',
        value: '21',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '售后公司已发货',
        code: 'sc_shipped',
        value: '23',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '售后公司已收货',
        code: 'sc_received',
        value: '22',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'CS,SC', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '租赁方已收货',
        code: 'cs_received',
        value: '24',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '已作废',
        code: 'cancelled',
        value: '100',
        children: [
          { roleCode: 'JV', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: '', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '审批拒绝',
        code: 'refuse',
        value: '90',
        children: [
          { roleCode: 'JV', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: 'JV', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: '', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '已终止',
        code: 'terminated',
        value: '70',
        children: [{ roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' }],
      },
      {
        name: '已到期',
        code: 'expired',
        value: '80',
        children: [
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'JV', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
        ],
      },
    ],
  },
  {
    name: '框架合同',
    code: 'fram',
    value: '30',
    children: [
      {
        name: '草稿',
        code: 'draft',
        value: '1',
        children: [
          { roleCode: 'HQ,SC', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'HQ,SC', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: 'HQ,SC', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'HQ,SC', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '审批中',
        code: 'approval',
        value: '6',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: 'HQ,SC', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: 'HQ,CS,SC', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'HQ,SC', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '审批通过',
        code: 'Pass',
        value: '10',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: 'HQ,SC', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },

          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '已生效',
        code: 'executed',
        value: '20',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'HQ,SC', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },

      {
        name: '已作废',
        code: 'cancelled',
        value: '100',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'HQ,SC', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: '', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '审批拒绝',
        code: 'refuse',
        value: '90',
        children: [
          { roleCode: 'JV', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: 'JV', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: '', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
    ],
  },

  {
    name: '试用订单',
    code: 't_order',
    value: '10',
    children: [
      {
        name: '已试用',
        code: 'try',
        value: '32',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: 'JV', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: 'HQ', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '草稿',
        code: 'draft',
        value: '1',
        children: [
          { roleCode: 'JV', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'JV', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: 'JV', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '审批中',
        code: 'approval',
        value: '6',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: 'JV', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: 'HQ,CS,SC', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '审批通过',
        code: 'Pass',
        value: '10',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: 'JV', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },

          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '已生效',
        code: 'executed',
        value: '20',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '总部已发货',
        code: 'hq_shipped',
        value: '21',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'CS,SC', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '售后公司已发货',
        code: 'sc_shipped',
        value: '23',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '售后公司已收货',
        code: 'sc_received',
        value: '22',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '租赁方已收货',
        code: 'cs_received',
        value: '24',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'CS,SC', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'hQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '已启租',
        code: 'lessee',
        value: '36',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'CS,SC', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: 'JV', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: 'HQ', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '已作废',
        code: 'cancelled',
        value: '100',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: '', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '审批拒绝',
        code: 'refuse',
        value: '90',
        children: [
          { roleCode: 'JV', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: 'JV', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: '', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '已终止',
        code: 'terminated',
        value: '70',
        children: [{ roleCode: 'HQ', name: '关闭订单', code: 'close', value: 'close' },
          { roleCode: 'JV', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: 'HQ', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '已到期',
        code: 'expired',
        value: '80',
        children: [
          { roleCode: 'HQ', name: '关闭订单', code: 'close', value: 'close' },
          { roleCode: 'JV', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: 'HQ', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
    ],
  },
  {
    name: '框架订单',
    code: 'f_order',
    value: '31',
    children: [
      {
        name: '已启租',
        code: 'lessee',
        value: '36',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: 'JV', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '草稿',
        code: 'draft',
        value: '1',
        children: [
          { roleCode: 'JV', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'JV', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: 'JV', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '审批中',
        code: 'approval',
        value: '6',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: 'JV', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: 'JV,HQ,CS,SC', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '审批通过',
        code: 'Pass',
        value: '10',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: 'JV', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' },
          { roleCode: '', name: '试用转协议', code: 'tryToOrder', value: 'tryToOrder' },
        ],
      },
      {
        name: '已生效',
        code: 'executed',
        value: '20',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '总部已发货',
        code: 'hq_shipped',
        value: '21',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '售后公司已发货',
        code: 'sc_shipped',
        value: '23',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '售后公司已收货',
        code: 'sc_received',
        value: '22',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'CS,SC', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '租赁方已收货',
        code: 'cs_received',
        value: '24',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '启租', code: 'start', value: 'start' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV,HQ,SC', name: '打印租赁确认单', code: 'printConfirmation', value: 'printConfirmation' },
          { roleCode: 'JV', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '已作废',
        code: 'cancelled',
        value: '100',
        children: [
          { roleCode: 'JV', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: '', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '审批拒绝',
        code: 'refuse',
        value: '90',
        children: [
          { roleCode: 'JV', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
          { roleCode: 'JV', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: 'JV', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: '', name: '启租', code: 'start', value: 'start' },
          { roleCode: '', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
          { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
          { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
        ],
      },
      {
        name: '已终止',
        code: 'terminated',
        value: '70',
        children: [{ roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' }],
      },
      {
        name: '已到期',
        code: 'expired',
        value: '80',
        children: [
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'JV', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
          { roleCode: 'JV', name: '拷贝', code: 'copy', value: 'copy' },
        ],
      },
    ],
  },
  {
    name: '销售订单',
    code: 'sales',
    value: '40',
    children: [
      {
        name: '已购机',
        code: 'sales',
        value: '52',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'SC,CS', name: '销售', code: 'sales', value: 'sales' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
          { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
        ],
      },
      {
        name: '部分已购机',
        code: 'part_sale',
        value: '51',
        children: [
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: 'SC,CS', name: '销售', code: 'sales', value: 'sales' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
        ],
      },
      {
        name: '草稿',
        code: 'draft',
        value: '1',
        children: [
          { roleCode: 'HQ,JV', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: 'HQ,JV', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: 'HQ,JV', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'HQ,JV', name: '查看', code: 'watch', value: 'watch' },
        ],
      },
      {
        name: '审批中',
        code: 'approval',
        value: '6',
        children: [
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: 'JV', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: 'JV,HQ,CS,SC', name: '审批', code: 'verify', value: 'verify' },
        ],
      },
      {
        name: '审批通过',
        code: 'Pass',
        value: '10',
        children: [{ roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' }],
      },
      {
        name: '已生效',
        code: 'executed',
        value: '20',
        children: [
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
        ],
      },
      {
        name: '总部已发货',
        code: 'hq_shipped',
        value: '21',
        children: [
          { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
          { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
          { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
          { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
          { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
        ],
      },
      {
        name: '售后公司已发货',
        code: 'sc_shipped',
        value: '23',
        children: [
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: 'SC,CS', name: '销售', code: 'sales', value: 'sales' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
        ],
      },

      {
        name: '租赁方已收货',
        code: 'cs_received',
        value: '24',
        children: [
          { roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' },
          { roleCode: 'SC,CS', name: '销售', code: 'sales', value: 'sales' },
          { roleCode: 'JV,HQ,SC', name: '打印发货单', code: 'printDelivery', value: 'printDelivery' },
          { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
          { roleCode: 'JV', name: '修改业务负责人', code: 'changeSalesman', value: 'changeSalesman' },
          { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
          { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
        ],
      },
      {
        name: '已作废',
        code: 'cancelled',
        value: '100',
        children: [{ roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' }],
      },
      {
        name: '审批拒绝',
        code: 'refuse',
        value: '90',
        children: [{ roleCode: 'JV,HQ,CS,SC', name: '查看', code: 'watch', value: 'watch' }],
      },
    ],
  },
  // {
  //   name: '框架订单',
  //   code: 'f_order',
  //   value: '31',
  //   children: [
  //     {
  //       name: '草稿',
  //       code: 'draft',
  //       value: '1',
  //       children: [
  //         { roleCode: 'HQ,SC', name: '编辑', code: 'edit', value: 'edit' },
  //         { roleCode: 'HQ,SC', name: '删除', code: 'delete', value: 'delete' },
  //         { roleCode: 'HQ,SC', name: '提交', code: 'submit', value: 'submit' },
  //         { roleCode: 'HQ,SC,CS', name: '查看', code: 'watch', value: 'watch' },
  //         { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
  //         { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
  //         { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
  //         { roleCode: '', name: '启租', code: 'start', value: 'start' },
  //         { roleCode: 'HQ,SC', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
  //         { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
  //         { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
  //         { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
  //         { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
  //         { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
  //         { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' }
  //       ]
  //     },
  //     {
  //       name: '审批中',
  //       code: 'approval',
  //       value: '6',
  //       children: [
  //         { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
  //         { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
  //         { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
  //         { roleCode: 'HQ,SC,CS', name: '查看', code: 'watch', value: 'watch' },
  //         { roleCode: 'HQ,SC', name: '撤销', code: 'cancel', value: 'cancel' },
  //         { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
  //         { roleCode: 'HQ,SC,CS', name: '审批', code: 'verify', value: 'verify' },
  //         { roleCode: '', name: '启租', code: 'start', value: 'start' },
  //         { roleCode: '', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
  //         { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
  //         { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
  //         { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
  //         { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
  //         { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
  //         { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' }
  //       ]
  //     },
  //     {
  //       name: '审批通过',
  //       code: 'Pass',
  //       value: '10',
  //       children: [
  //         { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
  //         { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
  //         { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
  //         { roleCode: 'HQ,SC,CS', name: '查看', code: 'watch', value: 'watch' },
  //         { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
  //         { roleCode: 'HQ,SC', name: '作废', code: 'revoke', value: 'revoke' },
  //         { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
  //         { roleCode: '', name: '启租', code: 'start', value: 'start' },
  //         { roleCode: 'HQ,SC', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
  //         { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
  //         { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
  //         { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
  //         { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
  //         { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
  //         { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' }
  //       ]
  //     },
  //     {
  //       name: '已生效',
  //       code: 'executed',
  //       value: '20',
  //       children: [
  //         { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
  //         { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
  //         { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
  //         { roleCode: 'HQ,SC,CS', name: '查看', code: 'watch', value: 'watch' },
  //         { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
  //         { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
  //         { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
  //         { roleCode: '', name: '启租', code: 'start', value: 'start' },
  //         { roleCode: 'HQ,SC', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
  //         { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
  //         { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
  //         { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
  //         { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
  //         { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
  //         { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' }
  //       ]
  //     },
  //     {
  //       name: '总部已发货',
  //       code: 'hq_shipped',
  //       value: '21',
  //       children: [
  //         { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
  //         { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
  //         { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
  //         { roleCode: 'HQ,SC,CS', name: '查看', code: 'watch', value: 'watch' },
  //         { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
  //         { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
  //         { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
  //         { roleCode: '', name: '启租', code: 'start', value: 'start' },
  //         { roleCode: 'HQ,SC', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
  //         { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
  //         { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
  //         { roleCode: 'CS,SC', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
  //         { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
  //         { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
  //         { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' }
  //       ]
  //     },
  //     {
  //       name: '售后公司已发货',
  //       code: 'sc_shipped',
  //       value: '23',
  //       children: [
  //         { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
  //         { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
  //         { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
  //         { roleCode: 'HQ,SC,CS', name: '查看', code: 'watch', value: 'watch' },
  //         { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
  //         { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
  //         { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
  //         { roleCode: '', name: '启租', code: 'start', value: 'start' },
  //         { roleCode: 'HQ,SC,CS', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
  //         { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
  //         { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
  //         { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
  //         { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
  //         { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
  //         { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' }
  //       ]
  //     },
  //     {
  //       name: '售后公司已收货',
  //       code: 'sc_received',
  //       value: '22',
  //       children: [
  //         { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
  //         { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
  //         { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
  //         { roleCode: 'HQ,SC,CS', name: '查看', code: 'watch', value: 'watch' },
  //         { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
  //         { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
  //         { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
  //         { roleCode: '', name: '启租', code: 'start', value: 'start' },
  //         { roleCode: 'HQ,SC', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
  //         { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
  //         { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
  //         { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
  //         { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
  //         { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
  //         { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' }
  //       ]
  //     },
  //     {
  //       name: '租赁方已收货',
  //       code: 'cs_received',
  //       value: '24',
  //       children: [
  //         { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
  //         { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
  //         { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
  //         { roleCode: 'HQ,SC,CS', name: '查看', code: 'watch', value: 'watch' },
  //         { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
  //         { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
  //         { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
  //         { roleCode: 'CS,SC', name: '启租', code: 'start', value: 'start' },
  //         { roleCode: 'HQ,SC', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
  //         { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
  //         { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
  //         { roleCode: 'SC,CS', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
  //         { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
  //         { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
  //         { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' }
  //       ]
  //     },
  //     {
  //       name: '已启租',
  //       code: 'lessee',
  //       value: '36',
  //       children: [
  //         { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
  //         { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
  //         { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
  //         { roleCode: 'HQ,SC,CS', name: '查看', code: 'watch', value: 'watch' },
  //         { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
  //         { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
  //         { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
  //         { roleCode: 'CS,SC', name: '启租', code: 'start', value: 'start' },
  //         { roleCode: 'HQ,SC', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
  //         { roleCode: 'HQ', name: '总部发货', code: 'factorySend', value: 'factorySend' },
  //         { roleCode: 'SC', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
  //         { roleCode: 'CS,SC', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
  //         { roleCode: 'SC', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
  //         { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
  //         { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' }
  //       ]
  //     },
  //     {
  //       name: '已作废',
  //       code: 'cancelled',
  //       value: '100',
  //       children: [
  //         { roleCode: '', name: '编辑', code: 'edit', value: 'edit' },
  //         { roleCode: 'HQ,SC', name: '拷贝', code: 'copy', value: 'copy' },
  //         { roleCode: '', name: '删除', code: 'delete', value: 'delete' },
  //         { roleCode: '', name: '提交', code: 'submit', value: 'submit' },
  //         { roleCode: 'HQ,SC,CS', name: '查看', code: 'watch', value: 'watch' },
  //         { roleCode: '', name: '撤销', code: 'cancel', value: 'cancel' },
  //         { roleCode: '', name: '作废', code: 'revoke', value: 'revoke' },
  //         { roleCode: '', name: '审批', code: 'verify', value: 'verify' },
  //         { roleCode: '', name: '启租', code: 'start', value: 'start' },
  //         { roleCode: '', name: '修改负责人', code: 'changeHead', value: 'changeHead' },
  //         { roleCode: '', name: '总部发货', code: 'factorySend', value: 'factorySend' },
  //         { roleCode: '', name: '售后公司发货', code: 'aftersaleSend', value: 'aftersaleSend' },
  //         { roleCode: '', name: '租赁方收货', code: 'partybReceive', value: 'partybReceive' },
  //         { roleCode: '', name: '售后收货', code: 'aftersaleReceive', value: 'aftersaleReceive' },
  //         { roleCode: '', name: '期末续机', code: 'dateEndContinue', value: 'dateEndContinue' },
  //         { roleCode: '', name: '试用转租赁', code: 'tryToUse', value: 'tryToUse' }
  //       ]
  //     }
  //   ]
  // }
];

export default {
  handleRules,
  changeRules,
};
